export default __webpack_public_path__ + "static/media/i5000.22e3c3bd.jpg";